<div class="main-wrapper" *ngIf="visible" (click)="clickOut($event)">
    <div
        #notificationContainer
        [ngClass]="['notification-overlay', visible ? 'show' : '']"
    >
        <div data-cy="pop-up-notification-message" class="subtitle bold">
            {{ message | translate }}
        </div>
        <div data-cy="pop-up-notification-close-button" class="close subtitle-smaller" (click)="closeNotification()">
            {{ closeButton | translate }}
        </div>
    </div>
</div>
